module.exports = __webpack_public_path__ + "img/apr.59ca1cf5.svg";